import classnames from 'classnames/bind'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'

// Components
import { ArrowRightIcon, DocumentIcon } from '../Icons'

// Methods
import { helpArticlePath } from '../../methods'

// Types
import type { HelpArticleSummary } from '@/api/fetchHelpArticle'

// Styles
import styles from '../../style.module.scss'

const cx = classnames.bind(styles)

type Props = {
  articles: HelpArticleSummary[]
  countryQuery?: string
}

const ArticleList = ({ articles, countryQuery }: Props) => {
  const { t } = useTranslation()

  if (articles.length === 0) {
    return <p className={cx('help-empty')}>{t('Help_Center_Empty')}</p>
  }

  return (
    <ul className={cx('help-article-list')}>
      {articles.map((article) => (
        <li key={article.id}>
          <Link className={cx('help-article-list__item')} href={helpArticlePath(article.id, countryQuery)}>
            <span className={cx('help-article-list__icon')}>
              <DocumentIcon />
            </span>
            <span className={cx('help-article-list__text')}>
              <span className={cx('help-article-list__title')}>{article.title}</span>
              {article.summary && <span className={cx('help-article-list__summary')}>{article.summary}</span>}
            </span>
            <span className={cx('help-article-list__arrow')}>
              <ArrowRightIcon size={16} />
            </span>
          </Link>
        </li>
      ))}
    </ul>
  )
}

export default ArticleList
